export const NAV_LIST = [
    {
        label: "Accueil",
        href: "/",
    },
    {
        label: "Organisation",
        href: "/organisation",
    },
];

export const TABS_ANNUAIRE = {
    ANNUAIRE: "ANNUAIRE",
    ORGANIGRAMME: "ORGANIGRAM",
};

export const DEBOUNCE_DELAY = 700; // is in milliseconds

export const I18N_NS_ANNUAIRE = "annuaire";

export const INIT_CONFIG = {
    horizontal: false,
    expandAll: true,
    collapsable: true,
    labelClassName: "bg-white",
};

export const initialStateExport = {
    personal: {
        secu: false,
        id_type: false,
        id_number: false,
        nationality: false,
        birthdate: false,
        gender: false,
        address: false,
    },
    contract: {
        job: false,
        contract_type: false,
        start_date: false,
        end_date: false,
        department: false,
    },
};
